import React from 'react';

/**
 * Component to display list of saved locations (for teachers)
 *
 * @param {Object} props
 * @param {Array} props.locations - Array of location objects
 * @param {Function} props.onLocationRemove - Callback to remove location
 * @param {Function} props.onSetDefault - Callback to set default location
 * @param {boolean} props.isArabic - RTL support
 */
const LocationList = ({ locations, onLocationRemove, onSetDefault, isArabic }) => {
  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 16 }}>
      <h4 style={{
        fontSize: 14,
        fontWeight: 700,
        color: '#1E293B',
        marginBottom: 12,
        textAlign: isArabic ? 'right' : 'left',
        fontFamily: "'IBM Plex Sans Arabic', sans-serif"
      }}>
        {isArabic ? 'المواقع المحفوظة' : 'Saved Locations'}
      </h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {locations.map((location) => (
          <div
            key={location.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              background: location.is_default ? '#fff6f0' : '#f8fafc',
              border: `2px solid ${location.is_default ? '#FF7426' : '#e2e8f0'}`,
              borderRadius: 12,
              transition: 'all 0.2s',
              direction: isArabic ? 'rtl' : 'ltr'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              flex: 1,
              flexDirection: isArabic ? 'row-reverse' : 'row'
            }}>
              <div style={{ fontSize: 16, flexShrink: 0 }}>
                📍
              </div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: '#1E293B',
                  marginBottom: 2,
                  textAlign: isArabic ? 'right' : 'left'
                }}>
                  {location.place_name || (isArabic ? 'موقع مخصص' : 'Custom Location')}
                  {location.is_default && (
                    <span style={{
                      marginLeft: isArabic ? 0 : 8,
                      marginRight: isArabic ? 8 : 0,
                      color: '#FF7426',
                      fontSize: 12
                    }}>
                      ({isArabic ? 'افتراضي' : 'Default'})
                    </span>
                  )}
                </div>
                <div style={{
                  fontSize: 12,
                  color: '#64748b',
                  textAlign: isArabic ? 'right' : 'left'
                }}>
                  {location.formatted_address}
                </div>
              </div>
            </div>
            <div style={{
              display: 'flex',
              gap: 8,
              flexDirection: isArabic ? 'row-reverse' : 'row'
            }}>
              {!location.is_default && onSetDefault && (
                <button
                  onClick={() => onSetDefault(location.id)}
                  style={{
                    padding: '8px 12px',
                    background: 'transparent',
                    border: '1px solid #e2e8f0',
                    borderRadius: 8,
                    cursor: 'pointer',
                    color: '#64748b',
                    fontSize: 12,
                    fontWeight: 600,
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#FF7426';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.borderColor = '#FF7426';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#64748b';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                  }}
                  title={isArabic ? 'تعيين كافتراضي' : 'Set as default'}
                >
                  ⭐
                </button>
              )}
              <button
                onClick={() => onLocationRemove(location.id)}
                style={{
                  padding: '8px 12px',
                  background: 'transparent',
                  border: '1px solid #e2e8f0',
                  borderRadius: 8,
                  cursor: 'pointer',
                  color: '#ef4444',
                  fontSize: 12,
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#ef4444';
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.borderColor = '#ef4444';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#ef4444';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
                title={isArabic ? 'حذف' : 'Delete'}
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationList;
